import { SlideInterface } from '@tencent/docs-api';
import { ISlideContentEnumeratorService } from '../../slide-content-enumerator/slide-content-enumerator-service.interface';
import { AnalyzerWrapper, BaseChecker } from '../base/base-checker';

type ICheckResult = SlideInterface.ITemplateCheckData;

export enum AnalyzerType {
    Review = 'review',
    Common = 'common',
    Other = 'other',
}

interface ReviewAnalyzer extends AnalyzerWrapper<SlideInterface.ITextReview> {
    type: AnalyzerType.Review;
}

interface CommonCheckAnalyzer extends AnalyzerWrapper<SlideInterface.CheckResultItem> {
    type: AnalyzerType.Common;
    id: SlideInterface.CheckResultItemRootIds;
}

interface otherCheckAnalyzer extends AnalyzerWrapper<unknown> {
    type: AnalyzerType.Other;
}

export class MachineAuditChecker extends BaseChecker<
    ReviewAnalyzer | CommonCheckAnalyzer | otherCheckAnalyzer,
    ICheckResult
> {
    public constructor(enumerator: ISlideContentEnumeratorService) {
        super(enumerator);
    }

    protected async getResult() {
        const res: Partial<ICheckResult> = { resultRootItem: [] };
        // eslint-disable-next-line no-restricted-syntax
        for (const analyzerInfo of this.analyzers) {
            const { type, analyzer } = analyzerInfo;
            if (type === AnalyzerType.Review) {
                res.reviewData = await analyzer.result;
            }
            if (type === AnalyzerType.Common) {
                const resList = res.resultRootItem?.find(i => i.id === analyzerInfo.id);
                if (resList) {
                    resList.resultItem?.push(await analyzer.result);
                } else {
                    res.resultRootItem?.push({ id: analyzerInfo.id, resultItem: [await analyzer.result] });
                }
            }
        }
        return res as ICheckResult;
    }
}
